import { render, staticRenderFns } from "./edit-charge-notify.vue?vue&type=template&id=1d4c8586&scoped=true"
import script from "./edit-charge-notify.vue?vue&type=script&lang=ts"
export * from "./edit-charge-notify.vue?vue&type=script&lang=ts"
import style0 from "./edit-charge-notify.vue?vue&type=style&index=0&id=1d4c8586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c8586",
  null
  
)

export default component.exports